import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2, Save } from "lucide-react";
import { api } from "@/lib/api";

const FIELDS = [
  ["legal_name", "Raison sociale / nom de l'entreprise", "sm:col-span-2"],
  ["line1", "Adresse de facturation", "sm:col-span-2"],
  ["line2", "Complément d'adresse (optionnel)", "sm:col-span-2"],
  ["postal_code", "Code postal", ""],
  ["city", "Ville", ""],
  ["country", "Pays (code ISO, ex. FR)", ""],
  ["billing_email", "Email de facturation", ""],
  ["siret", "SIRET (14 chiffres)", ""],
  ["siren", "SIREN (9 chiffres, si distinct)", ""],
];

export function BillingDetailsForm({ initial, onSaved }) {
  const [f, setF] = useState(initial || {});
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (initial) setF(initial); }, [initial]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/billing/me/billing-details", f);
      setF(data);
      toast.success(data.stripe_synced ? "Coordonnées enregistrées et synchronisées avec Stripe" : "Coordonnées de facturation enregistrées");
      onSaved && onSaved(data);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Vérifiez les champs obligatoires");
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="billing-details-card" className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <p className="font-heading font-bold text-brand-900 flex items-center gap-2"><Building2 className="w-4 h-4 text-accent-600" /> Coordonnées de facturation</p>
          <p className="text-sm text-slate-500 mt-1">Utilisées sur vos factures Stripe. Aucune donnée bancaire n'est conservée par SanitDocs.</p>
        </div>
        {!f.complete && <span data-testid="billing-details-incomplete" className="text-xs font-bold px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200">À compléter avant paiement</span>}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
        {FIELDS.map(([k, label, cls]) => (
          <label key={k} className={`text-xs font-semibold text-slate-600 ${cls}`}>
            {label}
            <input data-testid={`billing-${k}`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })}
              maxLength={k === "country" ? 2 : 120}
              className="mt-1 w-full h-10 px-3 rounded-lg border border-slate-200 text-sm font-normal text-slate-800 focus:outline-none focus:ring-2 focus:ring-accent-300" />
          </label>
        ))}
      </div>
      <div className="flex items-center justify-between gap-3 mt-4 flex-wrap">
        <p className="text-xs text-slate-400">{f.stripe_synced_at ? `Dernière synchronisation Stripe : ${new Date(f.stripe_synced_at).toLocaleString("fr-FR")}` : "Synchronisées vers Stripe avant tout paiement."}</p>
        <button data-testid="billing-details-save" onClick={save} disabled={saving}
          className="inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-brand-800 hover:bg-brand-900 text-white font-bold text-sm transition-colors disabled:opacity-60">
          <Save className="w-4 h-4" /> {saving ? "Enregistrement…" : "Enregistrer"}
        </button>
      </div>
    </div>
  );
}
